export var XMAS_DELIVERY_WIDGET_EXPERIMENT = "web_xmas_widget_nov_22";
export var PDP_DELIVERY_ESTIMATES_EXPERIMENT = "delivery_estimates_on_pdp";